<div *ngIf="!isCreatedOffer; else offerBlock">Loading...</div>
<ng-template #offerBlock>
  <div class="offer-id-container">{{'OFFER' | translate | uppercase }} № {{currentId}}</div>
  <div class="currency-type-container">
    <div class="currency-type-text" [class.selected]='selectedCurrency === "EUR"'
         (click)="changeSelectedCurrencyTo('EUR')">EUR
    </div>
  </div>
  <div class="currency-type-container">
    <div class="currency-type-text" [class.selected]='selectedCurrency === "BGN"'
         (click)="changeSelectedCurrencyTo('BGN')">лв
    </div>
  </div>
  <div class="offer-print-button" (click)="clickOnPrintOffer()">
    <img class="offer-print" [src]="printUrl" alt="print">
  </div>
  <div class="offer-pictures-container unselectable">
    <div class="offer-selected-picture-container">
      <img class="offer-selected-picture" *ngIf="selectedOffer.pictures[0]"
           src={{selectedOffer.pictures[selectedPictureIndex]}} alt="property picture"
           (click)="cliCkOpenFullScreenPicture()"/>
      <img class="offer-video-overlay" src="assets/images/video_overlay.png"
           *ngIf="selectedOffer.pictures[0] && selectedOffer.youtubeLink && selectedPictureIndex==0"/>
      <img class="offer-selected-picture" *ngIf="!selectedOffer.pictures[0]" src={{noImageAvailableUrl}}
           alt="property picture" (click)="cliCkOpenFullScreenPicture()"/>
      <div *ngIf="selectedOffer.isSellable && !selectedOffer.isAvailable"
           class="offer-preview-not-free">{{ 'SOLD' | translate | uppercase}}</div>
      <div *ngIf="!selectedOffer.isSellable && !selectedOffer.isAvailable"
           class="offer-preview-not-free">{{ 'RENTED' | translate | uppercase}}</div>
    </div>
    <div class="offer-pictures-slider-wrapper">
      <div class="offer-pictures-slider-container" [style.transform]="containerPositionTranslate">
        <div class="offer-picture-wrapper" *ngFor="let picture of selectedOffer.pictures; let i =index"
             (click)="clickOfferImage(i)">
          <img class="offer-picture" src={{picture}} alt="property picture"/>
          <img class="offer-video-overlay" src="assets/images/video_overlay.png"
               *ngIf="selectedOffer.youtubeLink && i==0"/>
        </div>
      </div>
    </div>
    <div class="offer-pictures-arrow-left-container" (click)="clickArrowLeft()">
      <div class="offer-pictures-arrow-left" [class.disabled]="!(selectedPictureIndex > 0)"></div>
    </div>
    <div class="offer-pictures-arrow-right-container" (click)="clickArrowRight()">
      <div class="offer-pictures-arrow-right"
           [class.disabled]="!(selectedPictureIndex < selectedOffer.pictures.length-1)"></div>
    </div>
  </div>

  <div class="offer-all-stats-key-values-pairs">
    <div class="offer-stats-pair">
      <div class="offer-field-key-text">{{'OFFER_TYPE' | translate | lowercase}}:</div>
      <div
        class="offer-field-value-text">{{(this.selectedOffer.isSellable ? 'SELLABLE' : 'RENTABLE') | translate}}</div>
    </div>
    <div class="offer-stats-pair">
      <div class="offer-field-key-text">{{'LOCATION' | translate | lowercase}}:</div>
      <div class="offer-field-value-text">{{selectedOffer.city | translatedb}}</div>
    </div>
    <div class="offer-stats-pair">
      <div class="offer-field-key-text">{{'AREA' | translate | lowercase}}:</div>
      <div class="offer-field-value-text">{{selectedOffer.area | translatedb }}</div>
    </div>
    <div class="offer-stats-pair">
      <div class="offer-field-key-text">{{'PROPERTY_TYPE' | translate | lowercase}}:</div>
      <div class="offer-field-value-text">{{selectedOffer.subType | translatedb }}</div>
    </div>
    <div class="offer-stats-pair">
      <div class="offer-field-key-text">{{'SPACE' | translate | lowercase}}:</div>
      <div class="offer-field-value-text">{{selectedOffer.space}} {{"SQUARE_METERS" | translate }}</div>
    </div>
    <div class="offer-stats-pair" *ngIf="selectedOffer.type.valueBg === 'къщи,вили'">
      <div class="offer-field-key-text">{{'YARD_SPACE' | translate | lowercase}}:</div>
      <div class="offer-field-value-text">{{selectedOffer.yardSpace}} {{"SQUARE_METERS" | translate }}</div>
    </div>
    <div class="offer-stats-pair" *ngIf="selectedOffer.buildingType &&
                                         selectedOffer.type.valueBg !== 'поземлени имоти' ">
      <div class="offer-field-key-text">{{'BUILDING_TYPE' | translate | lowercase}}:</div>
      <div class="offer-field-value-text">{{selectedOffer.buildingType | translatedb }}</div>
    </div>
    <div class="offer-stats-pair" *ngIf="selectedOffer.yearOfBuilt &&
                                         selectedOffer.type.valueBg !== 'поземлени имоти' ">
      <div class="offer-field-key-text">{{'YEAR_OF_BUILD' | translate | lowercase}}:</div>
      <div class="offer-field-value-text"> {{selectedOffer.yearOfBuilt}}</div>
    </div>
    <div class="offer-stats-pair" *ngIf="selectedOffer.floor &&
                                         selectedOffer.type.valueBg !== 'гаражи' &&
                                         selectedOffer.type.valueBg !== 'поземлени имоти' ">
      <div
        class="offer-field-key-text">{{'FLOOR' | translate | lowercase}}{{selectedOffer.subType.valueBg === 'къща' && languageKey === 'bg' ? 'и' : ''}}:
      </div>
      <div class="offer-field-value-text">{{selectedOffer.floor | translatedb }}</div>
    </div>
    <div class="offer-stats-pair" *ngIf="selectedOffer.specifications && selectedOffer.specifications.length>0">
      <div class="offer-field-key-text">{{"SPECIFICATIONS" | translate | lowercase}}:</div>
      <div class="offer-field-value-text">{{selectedOffer.getTranslatedSpecificationsString() | translatedb}}
      </div>
    </div>
    <div class="offer-stats-pair">
      <div class="offer-field-key-text">{{'PRICE' | translate | lowercase}}:</div>
      <div
        class="offer-field-value-text">{{offersService.getConvertedPrice(selectedOffer.price)}} {{ selectedCurrency | translate}}
      </div>
    </div>
    <div class="offer-stats-pair" *ngIf="canShowOnMiniMap()">
      <div class="offer-see-on-map" (click)="clickSeeOnMap()">{{'SEE_ON_MAP' | translate | lowercase}}
      </div>
    </div>
  </div>

  <div class="offer-description-container">
    <div class="offer-description-header">
      {{'DESCRIPTION' | translate}}
    </div>
    <div class="offer-description">{{selectedOffer.description | translatedb }}</div>
  </div>
  <app-offer-contact-form *ngIf="isContactFormShown" [parent]="this" [selectedOfferId]="selectedOffer.id"
                          [class.shown]="isContactFormShown"></app-offer-contact-form>
  <div class="offer-send-request-email" *ngIf="selectedOffer" (click)="clickSendRequest()">
    {{'SEND_REQUEST' |translate | uppercase}}
  </div>
  <div class="offer-likes-container" *ngIf="selectedOffer">
    <img class="offer-likes" src={{fbLikePngUrl}} alt="facebook like" (click)="clickOnLikeOffer()">
    <div class="offer-likes-value-container">
      <div class="offer-likes-value-text">
        {{selectedOffer.likeCounter}}
      </div>
    </div>
  </div>
  <div class="offer-user-container" *ngIf="selectedUser">
    <div class="offer-user-header">{{'CONTACT_PERSON' | translate}}</div>
    <div class="offer-user-picture-container">
      <img class="offer-user-picture" [src]="selectedUser.picture" alt="user picture"/>
    </div>
    <div class="offer-user-info-container">
      <div class="offer-user-name">{{selectedUser.name | translatedb }}</div>
      <div class="offer-user-phone-number">{{'PHONE' |translate | lowercase}}: {{selectedUser.phoneNumber}}
      </div>
      <div class="offer-user-mobile-number">{{'MOBILE' |translate | lowercase}}: {{selectedUser.mobileNumber}}
      </div>
      <div class="offer-user-email">{{'EMAIL' |translate | lowercase}}: {{selectedUser.email}}</div>
    </div>
  </div>
  <div class="similar-offers-hud" *ngIf="similarOffers && similarOffers.length>0">
    <div class="similar-offers-header">
      {{'SIMILAR_OFFERS' | translate | uppercase }}
    </div>
    <div class="similar-offers-container">
      <div class="similar-offer-container" *ngFor="let similarOffer of similarOffers"
           (click)="changeToDifferentOffer(similarOffer.id)">
        <div class="similar-offer-picture-container">
          <img class="similar-offer-picture" *ngIf="similarOffer.pictures[0]" src='{{ similarOffer.pictures[0]}}'
               alt="property picture">
          <img class="similar-offer-picture" *ngIf="!similarOffer.pictures[0]" src="{{noImageAvailableUrl}}"
               alt="property picture"/>
        </div>
        <div class="similar-offer-area">{{similarOffer.area | translatedb }}</div>
        <div class="similar-offer-price">{{offersService.getConvertedPrice(similarOffer.price)}} {{currencyType}}
        </div>
      </div>
    </div>
  </div>
  <div class="detailed-offer-overlay" (click)="closeMiniMap()" (click)="closeContactForm()"
       [class.hidden]="!isMiniMapShown && !isContactFormShown"></div>
  <app-mini-map [class.shown]="isMiniMapShown"></app-mini-map>
  <app-print-offer class="print-component" [selectedOffer]='selectedOffer' [selectedCurrency]='selectedCurrency'
                   [selectedUser]='selectedUser' *ngIf="isPrintableShown"></app-print-offer>
  <div class="offer-pictures-full-screen-container" [class.hidden]="!isFullScreenPictureVisible">
    <div class="offer-pictures-background" (click)="cliCkCloseFullScreenPicture()"></div>
    <div class="flex-items">
      <div class="offer-full-screen-pictures-arrow-left-container">
        <div class="offer-pictures-arrow-left" (click)="clickArrowLeft()"
             [class.disabled]="!(selectedPictureIndex > 0)">
        </div>
      </div>
      <div class="offer-full-screen-selected-picture-container">
        <img *ngIf="selectedOffer.pictures[0] && !(selectedPictureIndex == 0 && selectedOffer.youtubeLink)"
             class="offer-full-screen-selected-picture" [src]="selectedOffer.pictures[selectedPictureIndex]"
             alt="property picture"/>

        <iframe class="offer-full-screen-selected-video" *ngIf="selectedOffer.pictures[0] &&
                    selectedOffer.youtubeLink &&
                    selectedPictureIndex==0 &&
                    isFullScreenPictureVisible"
                [src]="this.sanitizer.bypassSecurityTrustResourceUrl(selectedOffer.youtubeLink+'?autoplay=1&rel=0')"
                frameborder="0" allow="autoplay" allowfullscreen></iframe>
        <img *ngIf="!selectedOffer.pictures[0]" class="offer-full-screen-selected-picture" src={{noImageAvailableUrl}}
             alt="property picture"/>
      </div>
      <div class="offer-full-screen-pictures-arrow-right-container">
        <div class="offer-pictures-arrow-right" (click)="clickArrowRight()"
             [class.disabled]="!(selectedPictureIndex < selectedOffer.pictures.length-1)"></div>
      </div>
    </div>
  </div>
  <div *ngIf="isFullScreenPictureVisible" class="close-button" [class.hidden]="!isFullScreenPictureVisible"
       (click)="cliCkCloseFullScreenPicture()"></div>
</ng-template>
